import React from 'react';

import { useTranslation } from 'providers/GILT.provider';

const TooltipDeposit = () => {
  const { t } = useTranslation();

  return (
    <div className="info-tooltip" data-bem="TooltipDeposit">
      <i>{t('clientConnect.tooltipGuide')}</i>
      <div className="client-info-icon">
        <span className="tooltip">
          <div className="tooltip-centered">{t('clientConnect.depositTooltipText')}</div>
        </span>
      </div>
    </div>
  );
};

export default TooltipDeposit;
